import React from "react";
import TextField from "@mui/material/TextField";

const NumberWidget = ({
  id,
  required,
  readonly,
  disabled,
  label,
  value,
  onChange,
  hideError = false,
  rawErrors = [],
  options = {},
}) => {
  const showError = !hideError && rawErrors.length > 0;

  const step = options?.step ?? "any";
  const inputType = options?.inputType ?? "number";
  const inputMode = options?.inputMode ?? "numeric";
  const isDecimal = String(step).includes(".") || step === "any";

  const min = options?.min ?? -Infinity;
  const max = options?.max ?? Infinity;
  const maxLength = options?.maxLength ?? null; 
  const digitsOnly = options?.digitsOnly ?? false; 

  const handleChange = (e) => {
    let val = e.target.value;

    // Allow empty
    if (val === "") {
      onChange(undefined);
      return;
    }

    if (digitsOnly) {
      val = val.replace(/\D/g, ""); // strip non-digits
      if (maxLength) val = val.slice(0, maxLength);
      onChange(val);
      return;
    }

    if (/^-?\d*\.?\d*$/.test(val)) {
      const num = isDecimal ? parseFloat(val) : parseInt(val, 10);
      if (num >= min && num <= max) {
        onChange(num);
      } else {
        e.preventDefault();
      }
    }
  };

  const handleKeyPress = (e) => {
    const char = e.key;
    const currentValue = e.currentTarget?.value ?? "";

    if (digitsOnly) {
      if (!/^[0-9]$/.test(char)) e.preventDefault();
      return;
    }

    if (!/^[0-9]$/.test(char)) {
      if (char === "." && isDecimal && !currentValue.includes(".")) return;
      e.preventDefault();
    }
  };

  return (
    <TextField
      id={id}
      label={label}
      type={digitsOnly ? "text" : inputType} 
      required={required}
      disabled={disabled}
      InputProps={{ readOnly: readonly }}
      value={value ?? ""}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      error={showError}
      helperText={showError ? '' : " "}
      fullWidth
      inputProps={{
        inputMode,
        step,
        maxLength: maxLength ?? undefined, 
        pattern: digitsOnly ? "[0-9]*" : undefined,
      }}
    />
  );
};

export default NumberWidget;
